/*
----------------------------
Module - smp-alerts
----------------------------
*/

import $ from 'jquery';

(function () {
    'use strict';

    squiz.fn.alerts = function() {

        function createDismissedAlertCookie($alert) {

            var alert_id = $alert.data("alert-id");

            if (alert_id) {
                
                console.log(alert_id);

                var cookie_name = "alert-" + alert_id;

                squiz.fn.setCookie(cookie_name, "dismissed", 7);

            }

        }

        function dismissAlert($alert) {

            createDismissedAlertCookie($alert);
            
            $alert.remove();

            if (!$alerts_wrapper.find(".smp-alert").length) {
                // Remove alerts wrapper if there are no more alerts;
                $alerts_wrapper.remove();
            }

        }

        function setupDismissAlertButton() {

            var $dismiss_buttons = $alerts_wrapper.find(".smp-alert__dismiss-btn");

            $dismiss_buttons.on("click", function(event) {

                var $dismissed_alert = $(event.target).closest(".smp-alert");

                dismissAlert($dismissed_alert);

            });

        }

        function init() {

            $alerts_wrapper = $(".smp-alerts");

            if ($alerts_wrapper.length) {

                setupDismissAlertButton();

            }

        }

        var $alerts_wrapper;
    
        return {
            init: init
        }

    }();
        
    document.addEventListener("DOMContentLoaded", function () {
        squiz.fn.alerts.init();
    });

}());
